import { Typography } from 'antd';
import { useParams } from 'react-router';
import { useGetProjectQuery } from '@ui/features/PatientRegistry/services/api';

export default function ProjectCrumb() {
    const { projectId } = useParams();

    const { data } = useGetProjectQuery(projectId!, {
        skip: !projectId,
    });

    const title = data?.title?.trim() || 'Project';

    return <Typography.Text ellipsis>{title}</Typography.Text>;
}
